import Icon from 'veui/components/Icon'

Icon.register({
  'link-break': {
    paths: [
      {
        d: 'M520.48 460.52a32 32 0 01-22.62-54.63l112.43-112.43A96 96 0 10474.52 157.7L362.09 270.13a32 32 0 01-45.25-45.26l112.43-112.43c62.38-62.38 163.89-62.38 226.27 0a160 160 0 010 226.28L543.11 451.15a31.9 31.9 0 01-22.63 9.37zm-181.72 195l113.13-113.16a32 32 0 00-45.25-45.25L293.5 610.25a96 96 0 01-135.76-135.77l113.13-113.13a32 32 0 00-45.25-45.26L112.48 429.23A160 160 0 00338.76 655.5zM289 160V96a32 32 0 00-64 0v64a32 32 0 0064 0zm-97 96a32 32 0 00-32-32H97a32 32 0 000 64h63a32 32 0 0032-32zm352 416v-64a32 32 0 00-64 0v64a32 32 0 0064 0zm160-160a32 32 0 00-32-32h-64a32 32 0 000 64h64a32 32 0 0032-32z'
      }
    ],
    width: '768',
    height: '768'
  }
})
